export default __webpack_public_path__ + "static/media/DSC_0509.bd75d9d0.jpg";